import { observable, computed, action } from 'mobx';
import { API_URL } from '../constants/constants';

export class CompanyStore {

  @observable
  company: string;

  constructor() {
    this.company = '';
  }

  @computed
  get selectedCompany() {
    return this.company;
  }

  @action
  setCompany(company: string) {
    this.company = company;
    this.setLocalStorage();
  }

  @action
  setLocalStorage() {
    localStorage.setItem('company', JSON.stringify(this.company));
  }

  @action
  getFromLocalStorage() {
    let storageString = localStorage.getItem('company');

    if (storageString) {
      let parsedData = JSON.parse(storageString);
      this.setCompany(parsedData);
    }
  }

  @action
  clearLocalStorage() {
    localStorage.removeItem('company');
  }

  @action
  clearStore() {
    this.company = '';
    this.clearLocalStorage();
  }

}

export default CompanyStore;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/CompanyStore.ts